// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ea1f304","239":"02b52bb2","455":"9e24b878"}[chunkId] + ".chunk.js";
};